/* eslint-disable @typescript-eslint/no-unused-vars */
import { SagaIterator } from '@redux-saga/types';
import { Action } from 'common/interfaces/root';
import { statisticsApi } from 'modules/overview/services/statistics.service';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { overviewActions, overviewActionTypes as T } from '../actions';

function* getAllStatisticsSaga({ payload }: Action) {
  try {
    const { data } = yield call(statisticsApi.getAllStatistics, payload);

    yield put(overviewActions.getAllStatisticsSuccess(data.statistics));
  } catch (err) {
    yield put(overviewActions.getAllStatisticsError(err as Error));
  }
}

function* getCorrelationStatisticsSaga({ payload }: Action) {
  try {
    const { data } = yield call(statisticsApi.getCorrelationStatistics, payload);

    yield put(overviewActions.getCorrelationStatisticsSuccess(data.statistics));
  } catch (err) {
    yield put(overviewActions.getCorrelationStatisticsError(err as Error));
  }
}

function* getDevicesStatisticsSaga({ payload }: Action) {
  try {
    const { data } = yield call(statisticsApi.getDevicesStatistics, payload);

    yield put(overviewActions.getDevicesStatisticsSuccess(data.devices));
  } catch (err) {
    yield put(overviewActions.getDevicesStatisticsError(err as Error));
  }
}

function* getTopAsinsSaga({ payload }: Action) {
  try {
    const { data } = yield call(statisticsApi.getTopAsins, payload);
    yield put(overviewActions.getTopAsinsSuccess(data.performers));
  } catch (err) {
    yield put(overviewActions.getTopPerformersError(err as Error));
  }
}

function* getTopCategoriesSaga({ payload }: Action) {
  try {
    const { data } = yield call(statisticsApi.getTopCategories, payload);
    yield put(overviewActions.getTopCategoriesSuccess(data.performers));
  } catch (err) {
    yield put(overviewActions.getTopPerformersError(err as Error));
  }
}

export function* overviewSaga(): SagaIterator {
  yield all([
    takeLatest(T.GET_ALL_STATISTICS, getAllStatisticsSaga),
    takeLatest(T.GET_CORRELATION_STATISTICS, getCorrelationStatisticsSaga),
    takeLatest(T.GET_DEVICES_STATISTICS, getDevicesStatisticsSaga),
    takeLatest(T.GET_TOP_PERFORMERS, getTopAsinsSaga),
    takeLatest(T.GET_TOP_PERFORMERS, getTopCategoriesSaga),
  ]);
}
